import { api } from '../client/client.js';
import { formatDateTime, formatDate, mapServerStatus } from '../format/format.js';

export function listUsers({ search, status } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (status && status !== 'all') params.set('status', status);
  const qs = params.toString();
  return api.get(`/users${qs ? `?${qs}` : ''}`);
}

export function getUserWithServers(id) {
  return api.get(`/users/${id}`).then((user) => ({
    ...user,
    servers: (user.servers || []).map((s) => ({
      id: s.id,
      name: s.name,
      plan: s.plan || '—',
      location: s.location || '—',
      ip: s.ip || '—',
      os: s.os || '—',
      status: mapServerStatus(s.status),
      provider: s.provider || '—',
      providerId: s.provider_id || '—',
      cpu: s.cpu ? `${s.cpu} vCPU` : '—',
      ram: s.ram ? `${s.ram} GB` : '—',
      storage: s.storage ? `${s.storage} GB` : '—',
      paid: Number(s.paid) || 0,
      cost: Number(s.cost) || 0,
      created: formatDate(s.created_at),
      expires: formatDate(s.expires_at),
    })),
  }));
}

export function toggleBan(id, reason, mode = 'suspend') {
  const body = { mode };
  if (reason) body.reason = reason;
  return api.patch(`/users/${id}/ban`, body);
}

export function updateBalance(id, balance) {
  return api.patch(`/users/${id}/balance`, { balance });
}

export function updateBonusBalance(id, bonusBalance) {
  return api.patch(`/users/${id}/bonus-balance`, { bonusBalance });
}
